import * as React from 'react';
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import {
    Button, Card, CardBody, CardText, CardTitle, Col, Collapse, Input, Label, Row, Table, Toast, ToastBody,
    ToastHeader
} from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, createAmendment, deleteCurrentVersion, EventGeneric, generateLocalStateFromEventProperties,
    getEventByName, getSelectedAfr, returnByDFS, updateVersionStateValue, verifiedByDFS,
    setAuditReceivedDate, setRequestDate, setJLACDate, JLACDate, isFundGroupOriented, loadAfr
} from '../../redux/AfrSlice';
import { resetConceptState } from "../../redux/ConceptSlice";
import { Entity, getSelectedEntity, selectedEntity, updateAfrStatus } from '../../redux/EntitySlice';
import { AfrEvents, AssignmentEvent, getSelectedEvents, getVersionEvents, loadEvents } from '../../redux/EventsSlice';
import { setIsDirty, isDirty, getReportNotify } from '../../redux/MiscSlice';
import { UserRoleEnum, nullUser, selectUser } from '../../redux/UserSlice';
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import EventList from '../feature/EventList';
import DiscrepancyEmail from './DiscrepancyEmail';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';

const SummaryAdministrationTab = function () {
    const dispatch = useAppDispatch();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const currentAfrEvents: AfrEvents | null = useAppSelector(getSelectedEvents);
    const versionHistory: Array<EventGeneric> | null = useAppSelector(getVersionEvents).reverse();
    const isDirtyInfo: boolean = useAppSelector(isDirty);
    const taxType: string | null = useAppSelector(getTaxonomyType);
    const selectedEntity: Entity | null = useAppSelector(getSelectedEntity);
    const user = useAppSelector(selectUser);
    const userRole = (user && user.userProfile) ? user.userProfile.role : UserRoleEnum.EntityUser.toString();
    const history = useHistory();

    const [assignedTo, setAssignedTo] = useState("");
    const [assignmentDate, setAssignmentDate] = useState("");
    const [chkVerifiedByDFS, setChkVerifiedByDFS] = useState(false);
    const [chkReturnedByDFS, setChkReturnedByDFS] = useState(false);
    const [btnCreateAmendtmentByDFS, setBtnCreateAmendtmentByDFS] = useState(false);
    const [returnedDate, setReturnedDate] = useState("");
    const [readOnlyVerifiedByDFS, setReadOnlyVerifiedByDFS] = useState(false);
    const [readonlyReturnedByDFS, setReadonlyReturnedByDFS] = useState(false);
    const [reqDate, setReqDate] = useState<any>();
    const [audReceivedDate, setAudReceivedDate] = useState<any>();
    const [canUseBalanceSheet, setCanUseBalanceSheet] = useState<boolean>(false);
    const [isAFR, setIsAFR] = useState<boolean>(true);
    const [is939, setIs939] = useState<boolean>(true);
    const [is29, setIs29] = useState<boolean>(true);
    const [hasAffiliates, setHasAffiliates] = useState<boolean>(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(isDirtyInfo);
    const [withholdingStartDates, setWithholdingStartDates] = React.useState<any>();
    const [beginEnforcementLetterIssueDate, setBeginEnforcementLetterIssueDate] = React.useState<any>();
    const [minAuditReceivedDate, setMinAuditReceivedDate] = React.useState<Date>(dateHelper.convertToDateOrDefault("2012-01-01"));

    const reviewSectionsForTaxonomyType = function (tt: string | null) {
        var result: string[] = [];
        if (isFundGroupOriented(currentAfr)) {
            if (utilityHelper.hasAffiliates(currentAfr)) {
                result = ["reviewState_generalInfoReviewed",
                    "reviewState_governmentalFundsReviewed",
                    "reviewState_proprietaryFundsReviewed",
                    "reviewState_fiduciaryFundsReviewed",
                    "reviewState_componentUnitsFundsReviewed",
                    "reviewState_debtReviewed",
                    "reviewState_supplementalReviewed",
                    "reviewState_componentUnitsReviewed",
                    "reviewState_auditReviewed",
                    "reviewState_certificationReviewed",
                    "adminState_jLACNonCompliance"
                ];
            } else {
                result = ["reviewState_generalInfoReviewed",
                    "reviewState_governmentalFundsReviewed",
                    "reviewState_proprietaryFundsReviewed",
                    "reviewState_fiduciaryFundsReviewed",
                    "reviewState_componentUnitsFundsReviewed",
                    "reviewState_debtReviewed",
                    "reviewState_supplementalReviewed",
                    "reviewState_componentUnitsReviewed",
                    "reviewState_auditReviewed",
                    "reviewState_certificationReviewed",
                    "adminState_jLACNonCompliance"
                ];
            }
        } else {
            result = ["reviewState_generalInfoReviewed",
                "reviewState_balanceSheetReviewed",
                "reviewState_expendituresReviewed",
                "reviewState_revenuesReviewed",
                "reviewState_debtReviewed",
                "reviewState_supplementalReviewed",
                "reviewState_componentUnitsReviewed",
                "reviewState_auditReviewed",
                "reviewState_certificationReviewed",
                "adminState_jLACNonCompliance"
            ];
        }
        if (tt) {
            switch (tt) {
                case "COURT_REPORTING_939":
                    result = ["reviewState_cr939CourtInnovationsReviewed",
                        "reviewState_cr939LegalAidProgramReviewed",
                        "reviewState_cr939LawLibraryReviewed",
                        "reviewState_cr939JuvenileAlternativeProgramReviewed",
                        "reviewState_cr939SummaryReviewed"]
                    break;

                case "COURT_REPORTING_29":
                    result = [
                        "reviewState_cr29PartAReviewed",
                        "reviewState_cr29PartBReviewed",
                        "reviewState_cr29PartCReviewed",
                        "reviewState_cr29PartDReviewed",
                        "reviewState_cr29PartEReviewed",
                        "reviewState_cr29CertificationReviewed"]
                    break;
            }
        }
        return result;
    }
    const reviewOptionsForTaxonomyType = function (useBS: boolean, useAff: boolean, tt: string | null) {
        var result: string[][] = [];

        if (tt) {
            switch (tt) {
                case "COURT_REPORTING_939":
                    result = [
                        ["reviewState_cr939CourtInnovationsReviewed", "Court Innovations"],
                        ["reviewState_cr939LegalAidProgramReviewed", "Legal Aid Program"],
                        ["reviewState_cr939LawLibraryReviewed", "Law Library"],
                        ["reviewState_cr939JuvenileAlternativeProgramReviewed", "Juvenile Alternative Program"],
                        ["reviewState_cr939SummaryReviewed", "Summary"]
                    ]
                    break;

                case "COURT_REPORTING_29":
                    result = [
                        ["reviewState_cr29PartAReviewed", "Part A"],
                        ["reviewState_cr29PartBReviewed", "Part B"],
                        ["reviewState_cr29PartCReviewed", "Part C"],
                        ["reviewState_cr29PartDReviewed", "Part D"],
                        ["reviewState_cr29PartEReviewed", "Part E"],
                        ["reviewState_cr29CertificationReviewed", "Certification"]]
                    break;

                default:
                    if (isFundGroupOriented(currentAfr)) {
                        result.push(["reviewState_governmentalFundsReviewed", "Governmental Funds"]);
                        result.push(["reviewState_proprietaryFundsReviewed", "Proprietary Funds"]);
                        result.push(["reviewState_fiduciaryFundsReviewed", "Fiduciary Funds"]);
                        if (utilityHelper.hasAffiliates(currentAfr)) {
                            result.push(["reviewState_componentUnitsFundsReviewed", "Discrete Component Units Funds"]);
                        }
                    } else {
                        if (useBS) {
                            result.push(["reviewState_balanceSheetReviewed", "Balance Sheet"]);
                        }
                        result.push(["reviewState_revenuesReviewed", "Revenues"]);
                        result.push(["reviewState_expendituresReviewed", "Expenditures"]);
                    }
                    result.push(["reviewState_debtReviewed", "Long-Term Debt"]);
                    if (currentAfr && currentAfr.year > 2020) {
                        result.push(["reviewState_supplementalReviewed", "Supplemental Information"]);
                    }
                    if (useAff) {
                        result.push(["reviewState_componentUnitsReviewed", "Affiliated Entities"]);
                    }
                    result.push(["reviewState_auditReviewed", "Audit"]);
                    result.push(["reviewState_certificationReviewed", "Certification"]);
                    break;
            }
        }
        return result;
    }
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, reviewSectionsForTaxonomyType(taxType)));

    const allSectionsReviewed = function (useBS: boolean, useAff: boolean, dirty: boolean, tt: string | null, newState: any): boolean {
        if (dirty) {
            return false;
        }
        var sections: string[] = [];
        if (tt) {
            switch (tt) {
                case "COURT_REPORTING_939":
                    sections = [
                        "reviewState_cr939CourtInnovationsReviewed",
                        "reviewState_cr939LegalAidProgramReviewed",
                        "reviewState_cr939LawLibraryReviewed",
                        "reviewState_cr939JuvenileAlternativeProgramReviewed",
                        "reviewState_cr939SummaryReviewed"
                    ];
                    break;

                case "COURT_REPORTING_29":
                    sections = [
                        "reviewState_cr29PartAReviewed",
                        "reviewState_cr29PartBReviewed",
                        "reviewState_cr29PartCReviewed",
                        "reviewState_cr29PartDReviewed",
                        "reviewState_cr29PartEReviewed",
                        "reviewState_cr29CertificationReviewed"
                    ];
                    break;

                default:
                    if (isFundGroupOriented(currentAfr)) {
                        if (utilityHelper.hasAffiliates(currentAfr)) {
                            sections = ["reviewState_governmentalFundsReviewed",
                                "reviewState_proprietaryFundsReviewed",
                                "reviewState_fiduciaryFundsReviewed",
                                "reviewState_componentUnitsFundsReviewed",
                                "reviewState_debtReviewed",
                                "reviewState_auditReviewed",
                                "reviewState_certificationReviewed"
                                ]
                        } else {
                            sections = ["reviewState_governmentalFundsReviewed",
                                "reviewState_proprietaryFundsReviewed",
                                "reviewState_fiduciaryFundsReviewed",
                                "reviewState_debtReviewed",
                                "reviewState_auditReviewed",
                                "reviewState_certificationReviewed"
                            ]
                        }
                    } else {
                        sections = [
                            "reviewState_expendituresReviewed",
                            "reviewState_revenuesReviewed",
                            "reviewState_debtReviewed",
                            "reviewState_auditReviewed",
                            "reviewState_certificationReviewed"
                        ]
                        if (useBS) {
                            sections.push("reviewState_balanceSheetReviewed");
                        }
                    }
                    
                    if (useAff) {
                        sections.push("reviewState_componentUnitsReviewed");
                    }
                    if (currentAfr && currentAfr.year > 2020) {
                        sections.push("reviewState_supplementalReviewed");
                    }
                    break;
            }
        }
        for (var section of sections) {
            if (newState[section] !== true) {
                return false;
            }
        }
        return true;
    }

    const currAssignment = function () {
        var assign: AssignmentEvent = {
            connector: "",
            creator: nullUser("creator"),
            assignee: nullUser("assignee"),
            timestamp: "",
            role: ""
        };
        if (currentAfrEvents) {
            for (var a of currentAfrEvents.assignmentEvents) {
                assign = a;
            }
        }
        return assign;
    }

    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    const handleCreateAmendment = function (event: any) {

        var htmlText = 'Please take into account that once you create a new Amendment the action cannnot be rolled back ' +
            'if you select <b>YES</b>.<br/><br/>' +
            'Do you want to proceed? ';

        var textResponse = 'Your new Amendment has been created.';

        if (currentAfr) {
            var entityIdValue = selectedEntity ? selectedEntity.code : "";
            var afrIdValue = currentAfr.afrId;
            var versionNumberValue = currentAfr.currentversion.versionNumber;
            var taxonomyTypeValue = currentAfr.taxonomyType ? currentAfr.taxonomyType.toString() : "";

            var afrVersionDetail: { entityId: string, afrId: string, versionNumber: number, taxononmyType: string }
                = {
                entityId: entityIdValue,
                afrId: afrIdValue,
                versionNumber: versionNumberValue,
                taxononmyType: taxonomyTypeValue 
            }

            dispatch(getReportNotify(afrVersionDetail)).then((result: any) => {

                const notifyResult = unwrapResult(result);

                if (notifyResult !== null) {

                    Swal.fire({
                        title: notifyResult.subject,
                        html: "This AFR has been modified and will now be refreshed.",
                        icon: 'warning',

                    })

                    // rollback changes
                    dispatch(loadAfr(currentAfr.afrId));
                    dispatch(loadEvents(currentAfr.afrId));
                    dispatch(resetConceptState({}));
                    //reset the dirty flag so the save/undo buttons disappear
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                    switch (taxType) {
                        case TaxonomyTypeEnum.COURT_REPORTING_939:
                            if (userRole === "ADMIN") {
                                history.push("/CourtReporting939AdminA");
                            } else {
                                history.push("/CourtReporting939Admin");
                            }
                            break;

                        case TaxonomyTypeEnum.COURT_REPORTING_29:
                            if (userRole === "ADMIN") {
                                history.push("/CR29AdminA");
                            } else {
                                history.push("/CR29Admin");
                            }
                            break;

                        default:
                            if (userRole === "ADMIN") {
                                history.push("/AfrSummaryA");
                            } else {
                                history.push("/AfrSummary");
                            }
                            break;
                    }


                } else {

                    Swal.fire({
                        title: 'Are you sure?',
                        html: htmlText,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, create it!'
                    }).then((result: any) => {
                        if (result.isConfirmed) {

                            // Update in redux
                            var commitCall: any = {
                                currentAfr: currentAfr,
                                changedVersionStates: null,
                                submit: false
                            }
                            dispatch(createAmendment(commitCall));
                            dispatch(loadEvents(currentAfr.afrId));
                            dispatch(resetConceptState({}));
                            setBtnCreateAmendtmentByDFS(true);

                            Swal.fire(
                                'Created!',
                                textResponse,
                                'success'
                            )
                        }

                    });
                }
            });         
        }
    }

    const handleDeleteVersion = function (event: any) {

        var htmlText = 'Please take into account that once you delete a version the action cannnot be rolled back ' +
            'if you select <b>YES</b>.<br/><br/>' +
            'Do you want to proceed? ';

        var textResponse = 'Your current version has been deleted.';

        if (currentAfr) {

            var entityIdValue = selectedEntity ? selectedEntity.code : "";
            var afrIdValue = currentAfr.afrId;
            var versionNumberValue = currentAfr.currentversion.versionNumber;
            var taxonomyTypeValue = currentAfr.taxonomyType ? currentAfr.taxonomyType.toString() : "";

            var afrVersionDetail: { entityId: string, afrId: string, versionNumber: number, taxononmyType: string }
                = {
                entityId: entityIdValue,
                afrId: afrIdValue,
                versionNumber: versionNumberValue,
                taxononmyType: taxonomyTypeValue
            }

            dispatch(getReportNotify(afrVersionDetail)).then((result: any) => {

                const notifyResult = unwrapResult(result);

                if (notifyResult !== null) {

                    Swal.fire({
                        title: notifyResult.subject,
                        html: "This AFR has been modified and will now be refreshed.",
                        icon: 'warning',

                    })

                    // rollback changes
                    dispatch(loadAfr(currentAfr.afrId));
                    dispatch(loadEvents(currentAfr.afrId));
                    dispatch(resetConceptState({}));
                    //reset the dirty flag so the save/undo buttons disappear
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                    switch (taxType) {
                        case TaxonomyTypeEnum.COURT_REPORTING_939:
                            if (userRole === "ADMIN") {
                                history.push("/CourtReporting939AdminA");
                            } else {
                                history.push("/CourtReporting939Admin");
                            }
                            break;

                        case TaxonomyTypeEnum.COURT_REPORTING_29:
                            if (userRole === "ADMIN") {
                                history.push("/CR29AdminA");
                            } else {
                                history.push("/CR29Admin");
                            }
                            break;

                        default:
                            if (userRole === "ADMIN") {
                                history.push("/AfrSummaryA");
                            } else {
                                history.push("/AfrSummary");
                            }
                            break;
                    }

                } else {

                    Swal.fire({
                        title: 'Are you sure?',
                        html: htmlText,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, delete it!'
                    }).then((result: any) => {
                        if (result.isConfirmed) {

                            // Update in redux
                            var commitCall: any = {
                                currentAfr: currentAfr,
                                changedVersionStates: null,
                                submit: false
                            }
                            dispatch(deleteCurrentVersion(commitCall));
                            dispatch(loadEvents(currentAfr.afrId));
                            dispatch(resetConceptState({}));


                            Swal.fire(
                                'Version deleted!',
                                textResponse,
                                'success'
                            )
                        }

                    });

                }
            });

        }
    }



    const handleJLACCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        if (value != true) {
            let withholdingDate: JLACDate =
            {
                dateType: "WITHHOLDING_START_DATES",
                dateValue: null
            };

            let enforcementDate: JLACDate =
            {
                dateType: "BEGIN_ENFORCEMENT_LETTER_ISSUE_DATE",
                dateValue: null
            };

            setWithholdingStartDates('');
            setBeginEnforcementLetterIssueDate('');
            dispatch(setJLACDate(withholdingDate));
            dispatch(setJLACDate(enforcementDate));
        }

    }

    const handleWithholdingStartDates = function (event: any) {

        let jlacDateValue: JLACDate =
        {
            dateType: "WITHHOLDING_START_DATES",
            dateValue: null
        }

        if (event && isNaN(Date.parse(event)) == false) {
            var dateString = dateHelper.formatDateToISO(event);
            if (dateString != withholdingStartDates) {
                setWithholdingStartDates(new Date(dateString));
                jlacDateValue.dateValue = dateString;
            }
        } else {
            setWithholdingStartDates('');
        }

        if (currentAfr != null
            && currentAfr.currentversion
            && currentAfr.currentversion.withholdingStartDates != jlacDateValue.dateValue) {
            // set the dirty flag to TRUE
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
        }

        dispatch(setJLACDate(jlacDateValue));

    }

    const handlebeginEnforcementLetterIssueDate = function (event: any) {

        let jlacDateValue: JLACDate =
        {
            dateType: "BEGIN_ENFORCEMENT_LETTER_ISSUE_DATE",
            dateValue: null
        };

        if (event && isNaN(Date.parse(event)) == false) {
            var dateString = dateHelper.formatDateToISO(event);
            if (dateString != withholdingStartDates) {
                setBeginEnforcementLetterIssueDate(new Date(dateString));
                jlacDateValue.dateValue = dateString;
            }
        } else {
            setBeginEnforcementLetterIssueDate('');
        }

        if (currentAfr != null
            && currentAfr.currentversion
            && currentAfr.currentversion.beginEnforcementLetterIssueDate != jlacDateValue.dateValue) {
            // set the dirty flag to TRUE
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
        }

        dispatch(setJLACDate(jlacDateValue));
    }



    const handleChangeCheckbox = function (event: React.FocusEvent<HTMLInputElement>) {
        // Update in redux
        event.persist();
        var isChecked = event.target.checked;
        if (currentAfr) {

            var entityIdValue = selectedEntity ? selectedEntity.code : "";
            var afrIdValue = currentAfr.afrId;
            var versionNumberValue = currentAfr.currentversion.versionNumber;
            var taxonomyTypeValue = currentAfr.taxonomyType ? currentAfr.taxonomyType.toString() : "";

            var afrVersionDetail: { entityId: string, afrId: string, versionNumber: number, taxononmyType: string }
                = {
                entityId: entityIdValue,
                afrId: afrIdValue,
                versionNumber: versionNumberValue,
                taxononmyType: taxonomyTypeValue
            }

            dispatch(getReportNotify(afrVersionDetail)).then((result: any) => {

                const notifyResult = unwrapResult(result);

                if (notifyResult !== null) {

                    Swal.fire({
                        title: notifyResult.subject,
                        html: "This AFR has been modified and will now be refreshed.",
                        icon: 'warning',

                    })

                    // rollback changes
                    dispatch(loadAfr(currentAfr.afrId));
                    dispatch(loadEvents(currentAfr.afrId));
                    dispatch(resetConceptState({}));
                    //reset the dirty flag so the save/undo buttons disappear
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                    switch (taxType) {
                        case TaxonomyTypeEnum.COURT_REPORTING_939:
                            if (userRole === "ADMIN") {
                                history.push("/CourtReporting939AdminA");
                            } else {
                                history.push("/CourtReporting939Admin");
                            }
                            break;

                        case TaxonomyTypeEnum.COURT_REPORTING_29:
                            if (userRole === "ADMIN") {
                                history.push("/CR29AdminA");
                            } else {
                                history.push("/CR29Admin");
                            }
                            break;

                        default:
                            if (userRole === "ADMIN") {
                                history.push("/AfrSummaryA");
                            } else {
                                history.push("/AfrSummary");
                            }
                            break;
                    }

                } else {

                    var commitCall: any = {
                        currentAfr: currentAfr,
                        changedVersionStates: null,
                        submit: false
                    }
                    switch (event.target.name) {
                        case "chkVerifiedByDFS":
                            var newStatus: string = isChecked ? "VERIFIED" : "CERTIFIED_BY_ENTITY";

                            var htmlTextVerified = 'Once the AFR is verified, this action cannot be rolled back. ' +
                                '<br/><br/>' +
                                'Do you want to verify the AFR? ';

                            Swal.fire({
                                title: 'Are you sure?',
                                html: htmlTextVerified,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes, verify it!'
                            }).then((result: any) => {
                                if (result.isConfirmed) {

                                    dispatch(verifiedByDFS(commitCall)).then((result: any) => {
                                        dispatch(updateAfrStatus({ afrYear: currentAfr.year, type: currentAfr.taxonomyType, logicalPeriod: currentAfr.logicalPeriod, status: newStatus }));
                                        setChkVerifiedByDFS(isChecked);
                                        if (!isChecked) {
                                            setReadOnlyVerifiedByDFS(true);
                                        }
                                    });                               
                                }
                            });

                            break;
                        case "chkReturnedByDFS":
                            var newStatus: string = isChecked ? "RETURNED_BY_DFS" : "IN_PROGRESS";

                            var htmlTextReturnedByDFS = 'Once the AFR is returned, this action cannot be rolled back. ' +
                                '<br/><br/>' +
                                'Do you want to return the AFR? ';

                            Swal.fire({
                                title: 'Are you sure?',
                                html: htmlTextReturnedByDFS,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes, return it!'
                            }).then((result: any) => {

                                if (result.isConfirmed) {
                                    dispatch(returnByDFS(commitCall)).then((result: any) => {
                                        dispatch(updateAfrStatus({ afrYear: currentAfr.year, type: currentAfr.taxonomyType, logicalPeriod: currentAfr.logicalPeriod, status: newStatus }));
                                        setChkReturnedByDFS(isChecked)
                                    });
                                }
                            });
    
                            break;

                    }

                    // This is now done in the useEffect below
                    //              dispatch(loadEvents(currentAfr.afrId));
                    dispatch(resetConceptState({}));

                }
            });
        }

    }

    const handleAuditReceivedDateChange = function (dateEntered: any) {
        // set the dirty flag to TRUE
        if (!dateEntered || dateEntered.length === 0) {
            dispatch(setAuditReceivedDate(null));
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
            return;
        }
        if (isNaN(Date.parse(dateEntered))) {
            return;
        }
        var date = dateHelper.formatDateToISO(dateEntered);
        dispatch(setAuditReceivedDate(date));
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));
    }

    const handleRequestDateChange = function (dateEntered: any) {
        // set the dirty flag to TRUE
        if (isNaN(Date.parse(dateEntered))) {
            return;
        }
        var date = dateHelper.formatDateToISO(dateEntered);
        dispatch(setRequestDate(date));
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));
    }

    const updateReadOnlyVerifiedStatus = function (useBalanceSheet: boolean, useAffiliates: boolean, isAfrVerified: boolean, currentDirtyState : boolean, newState: any) {
        /* Tori Said:
           Shouldn't be able to change status to Returned By DFS without the
           status being Certified by Entity or Re-certified by Entity first  */
         setReadonlyReturnedByDFS((!(currentAfr && (currentAfr.status.includes(enums.AFRStatus.certified) || currentAfr.status.includes(enums.AFRStatus.recertified)))));
        // ------------------------------------------------------------------------------------------------------------ 
        if (!currentAfr) {
            setReadOnlyVerifiedByDFS(true);
        } else if (isAfrVerified) {
            // If verified is checked then always enable to control so it can be turned off
            setReadOnlyVerifiedByDFS(false);
        } else if (!(currentAfr.status.includes(enums.AFRStatus.certified) || currentAfr.status.includes(enums.AFRStatus.recertified) || currentAfr.status.includes(enums.AFRStatus.verified))) {
            setReadOnlyVerifiedByDFS(true);
        } else {
            var bFlag = allSectionsReviewed(useBalanceSheet, useAffiliates, currentDirtyState, taxType, newState);
            setReadOnlyVerifiedByDFS(!bFlag)
        }

    }
    const finishInitialization = function (curAfr : Afr, useBalanceSheet : boolean, isAfrVerified : boolean, useAffiliates : boolean, currentDirtyState : boolean, newLocalState : any ) {
        setState(newLocalState);
        if (isAfrVerified) {
            // If verified is checked then always enable to control so it can be turned off
            setReadOnlyVerifiedByDFS(false);
        } else if (!(curAfr.status.includes(enums.AFRStatus.certified) || curAfr.status.includes(enums.AFRStatus.recertified) || curAfr.status.includes(enums.AFRStatus.verified))) {
            setReadOnlyVerifiedByDFS(true);
        } else {
            var bFlag = allSectionsReviewed(useBalanceSheet, useAffiliates, currentDirtyState, taxType, newLocalState);
            setReadOnlyVerifiedByDFS(!bFlag)
        }

        if (curAfr.auditReceivedDate) {
            if (curAfr.auditReceivedDate === "*") {
                if (curAfr.currentversion && curAfr.currentversion.audit && curAfr.currentversion.audit.auditPdf) {
                    setAudReceivedDate(dateHelper.convertToDate(curAfr.currentversion.audit.auditPdf.timestamp));
                } else {
                    setAudReceivedDate(null);
                }
            } else {
                setAudReceivedDate(dateHelper.convertToDate(curAfr.auditReceivedDate));
            }
        } else {
            setAudReceivedDate(null);
        }

        // get returned by dfs date if it exists
        var event = getEventByName(curAfr, enums.eventName.returned_by_dfs);

        if (event) {
            setReturnedDate(dateHelper.stringDateInFormat(event.date, "LL/dd/yyyy"));

        }
        if (curAfr.requestDate) {
            var newRequestDate = dateHelper.convertToDate(curAfr.requestDate);
            if (newRequestDate !== null) {
                setReqDate(newRequestDate);
            }
        } else {
            setReqDate(null);
        }

        // get state from redux
//        var newLocalState = generateLocalStateFromEventProperties(currentAfr, reviewSectionsForTaxonomyType(taxType));



        // create a local state from redux
//        setState(newLocalState);

        if (curAfr.currentversion.withholdingStartDates != null) {
            var withholdingDateString = dateHelper.formatDateToISO(curAfr.currentversion.withholdingStartDates);
            var existingWitholdingDateString = dateHelper.formatDateToISO(withholdingStartDates);
            if (withholdingDateString != existingWitholdingDateString) {
                setWithholdingStartDates(new Date(withholdingDateString));
            }
        } else {
            setWithholdingStartDates(null);
        }

        if (curAfr.currentversion.beginEnforcementLetterIssueDate != null) {
            var enforcementDateString = dateHelper.formatDateToISO(curAfr.currentversion.beginEnforcementLetterIssueDate);
            var existingEnforcementDateString = dateHelper.formatDateToISO(beginEnforcementLetterIssueDate);
            if (enforcementDateString != existingEnforcementDateString) {
                setBeginEnforcementLetterIssueDate(new Date(enforcementDateString));
            }
        } else {
            setBeginEnforcementLetterIssueDate(null);
        }

    }
    const hasAuditPerformed = function (afr: Afr | null): string | null {
        if (currentAfr && currentAfr.currentversion && currentAfr.currentversion.audit && currentAfr.currentversion.audit.datePerformed) {
            return currentAfr.currentversion.audit.datePerformed;
        }
        return null;
    }

    useEffect(() => {
        var event: EventGeneric | null;
        setAssignedTo(currAssignment().assignee.lastName);
        var isAfrVerified = (currentAfr && currentAfr.status === enums.AFRStatus.verified) ? true : false;
        setAssignmentDate(dateHelper.stringDateInFormat(currAssignment().timestamp, "LL/dd/yyyy"));
        setChkVerifiedByDFS(isAfrVerified);
        setChkReturnedByDFS((currentAfr && currentAfr.status === enums.AFRStatus.returned_by_dfs) ? true : false);
        setReadOnlyVerifiedByDFS(false);
        setReadonlyReturnedByDFS(false);

        setReturnedDate("");
        setReqDate(null);
        setAudReceivedDate(null);
        setMinAuditReceivedDate(dateHelper.convertToDateOrDefault("2012-01-01"));
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;

        // NOTE We assign the boolean values to local variable so the can be used to assign state, but also to pass into allSectionsReviewed. We can't use the state variables directly in that function becuase their new values will not
        // be available inside the useEffect.
        var useBalanceSheet = false;
        var useAFR = false;
        var use939 = false;
        var use29 = false;


        var useBalanceSheet = (currentAfr.year >= 2022);
        switch (taxType) {
            case "AFR":
                useAFR = true;
                if (hasAuditPerformed(currentAfr)) {
                    setMinAuditReceivedDate(dateHelper.convertToDateOrDefault(hasAuditPerformed(currentAfr)));
                }
                break;
            case "COURT_REPORTING_939":
                use939 = true;
                break;
            case "COURT_REPORTING_29":
                use29 = true;
                break;
        }
        var useAffiliates = false;
        setCanUseBalanceSheet(useBalanceSheet);
        setIsAFR(useAFR);
        setIs939(use939);
        setIs29(use29);
        if (currentAfr && currentAfr.affiliateReporting && currentAfr.affiliateReporting.length > 0) {
            setHasAffiliates(true);
            useAffiliates = true;
        } else {
            setHasAffiliates(false);
        }
        /* Tori Said:
           Shouldn't be able to change status to Returned By DFS without the
           status being Certified by Entity or Re-certified by Entity first  */
        setReadonlyReturnedByDFS((!(currentAfr && (currentAfr.status.includes(enums.AFRStatus.certified) || currentAfr.status.includes(enums.AFRStatus.recertified)))));
        // ------------------------------------------------------------------------------------------------------------ 
        var newState: any = state;
        dispatch(loadEvents(currentAfr.afrId));
        finishInitialization(currentAfr, useBalanceSheet, isAfrVerified, useAffiliates, isDirtyInfo,
            generateLocalStateFromEventProperties(currentAfr, reviewSectionsForTaxonomyType(taxType)));
    }, [currentAfr, currVersion()]);

    useEffect(() => {
       var isAfrVerified = (currentAfr && currentAfr.status === enums.AFRStatus.verified) ? true : false;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, reviewSectionsForTaxonomyType(taxType));
        // create a local state from redux
        setState(newLocalState);
        var useBalanceSheet = false;
        if (currentAfr) {
            useBalanceSheet = !utilityHelper.isSectionExcludedByYear(enums.UISection.balanceSheet, currentAfr.year.toString());
        }
        setCanUseBalanceSheet(useBalanceSheet);
        
        updateReadOnlyVerifiedStatus(useBalanceSheet, hasAffiliates, isAfrVerified, hasUnsavedChanges, newLocalState);
    }, []);

    // Updating the dirty state is a check on the verify check box. We only allow verification to be set if the current state of the AFR is save, and the current state permits verification:
    // 1. The existing status is certified or recertified.
    // 2. All relevant sections have been reviewed.
    useEffect(() => {
        setHasUnsavedChanges(isDirtyInfo);
        var isAfrVerified = (currentAfr && currentAfr.status === enums.AFRStatus.verified) ? true : false;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, reviewSectionsForTaxonomyType(taxType));
        // create a local state from redux
        setState(newLocalState);
        var useBalanceSheet = false;
        if (currentAfr) {
            useBalanceSheet = !utilityHelper.isSectionExcludedByYear(enums.UISection.balanceSheet, currentAfr.year.toString());
        }
        setCanUseBalanceSheet(useBalanceSheet);

        updateReadOnlyVerifiedStatus(useBalanceSheet, hasAffiliates, isAfrVerified, isDirtyInfo, newLocalState);
    }, [currentAfr, currVersion(), isDirtyInfo]);

    return (
        <div>
            {!currentAfr || currentAfr.status.toLowerCase() === "reported_by_primary"
                ?
                <Row>
                    <Col md="9">
                        <EventList types="version" eventsToShow={versionHistory} title="Version history" />
                    </Col>
                </Row>
                :
                <Row className="my-3">
                    <Col md="3">
                        <Toast className="auditDetail">
                            <ToastHeader className="auditDetail">Reviewed Items</ToastHeader>
                            <ToastBody>
                                <div>
                                    <Table borderless >
                                        <tbody>
                                            {reviewOptionsForTaxonomyType(canUseBalanceSheet, hasAffiliates, taxType).map((option, idx) => (
                                                <tr>
                                                    <td>
                                                        <Label className="ml-4" key={option[0]} check>
                                                            <Input type="checkbox"
                                                                name={option[0]}
                                                                readOnly={true}
                                                                checked={state[option[0]] ? true : false}
                                                            />{option[1]}
                                                        </Label>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </ToastBody>

                        </Toast>
                        {
                            taxType === "AFR"
                                ?
                                <Card body>
                                    <CardTitle></CardTitle>
                                    <CardText>
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <Col>
                                                        <Label className="ml-5" check>
                                                            <Input type="checkbox"
                                                                name="adminState_jLACNonCompliance"
                                                                onChange={handleJLACCheckbox}
                                                                checked={state["adminState_jLACNonCompliance"] ? true : false}
                                                            /><b>JLAC Flag</b>
                                                        </Label>
                                                    </Col>
                                                </Row>

                                                <Collapse isOpen={state["adminState_jLACNonCompliance"] ? true : false} className="ml-4">
                                                    <Row>
                                                        <Col>
                                                            <Label>Begin Enforcement Letter Issue Date:  </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <DatePicker
                                                                selected={beginEnforcementLetterIssueDate}
                                                                dateFormat="MM/dd/yyyy"
                                                                onChange={handlebeginEnforcementLetterIssueDate}
                                                            />

                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>Witholding Start Date:  </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <DatePicker
                                                                selected={withholdingStartDates}
                                                                dateFormat="MM/dd/yyyy"
                                                                onChange={handleWithholdingStartDates}
                                                            />
                                                        </Col>
                                                    </Row>                                                  
                                                </Collapse>

                                            </Col>
                                        </Row>
                                    </CardText>
                                </Card>
                                :
                                <div></div>
                        }

                    </Col>
                    <Col md="9">
                        <Row>
                            <Col>
                                <EventList types="version" eventsToShow={versionHistory} title="Version history" />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card body>
                                    <CardBody >
                                        <Table borderless >
                                            <tbody>
                                                {
                                                    taxType === "AFR"
                                                        ?
                                                        <tr>
                                                            <td className="col-4">
                                                                <Row style={{ flexDirection: "row" }}>
                                                                    <Label className="ml-4" check>
                                                                        <b>Audit Received Date: </b>
                                                                    </Label>
                                                                    <div style={{ marginLeft: "0.5em" }}>
                                                                        <DatePicker
                                                                            name="auditReceivedDate"
                                                                            selected={audReceivedDate}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            onChange={handleAuditReceivedDateChange}
                                                                            className="red-border"
                                                                            disabled={hasAuditPerformed(currentAfr) === null}
                                                                            minDate={minAuditReceivedDate}
                                                                            maxDate={new Date()}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                            </td>
                                                            <td className="col-4">
                                                            </td>
                                                        </tr>
                                                        :
                                                        <tr></tr>
                                                }
                                                <tr>
                                                    <td className="col-4">
                                                        {
                                                            (<Label className="ml-5" check>
                                                                <Input type="checkbox"
                                                                    name="chkReturnedByDFS"
                                                                    onChange={ handleChangeCheckbox }
                                                                    disabled={readonlyReturnedByDFS}
                                                                    checked={chkReturnedByDFS}
                                                                /><b>Returned by DFS:</b>
                                                            </Label>)}
                                                    </td>
                                                    <td className="col-4">
                                                        <Row style={{ flexDirection: "row" }}>
                                                            <Label className="ml-4" check>
                                                                <b>Request Date: </b>
                                                            </Label>
                                                            <div style={{ marginLeft: "0.5em" }}>
                                                                <DatePicker
                                                                    name="requestDate"
                                                                    selected={reqDate}
                                                                    dateFormat="MM/dd/yyyy"
                                                                    onChange={handleRequestDateChange}
                                                                    className="red-border"
                                                                    maxDate={new Date()}
                                                                />
                                                            </div>
                                                        </Row>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="col-4">
                                                        <Label className="ml-5" check>
                                                            <Input type="checkbox"
                                                                name="chkVerifiedByDFS"
                                                                onChange={handleChangeCheckbox}
                                                                disabled={readOnlyVerifiedByDFS || (chkVerifiedByDFS && chkVerifiedByDFS == true)}
                                                                checked={chkVerifiedByDFS}
                                                            /><b>Verified by DFS:</b>
                                                        </Label>
                                                    </td>
                                                    <td className="col-4">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Row style={{ justifyContent: "center" }}>
                                            <Button type="button" name="btnAmendment"
                                                disabled={(currentAfr != null && currentAfr != undefined) && (currentAfr.status != 'VERIFIED')}
                                                onClick={handleCreateAmendment}>Create Amendment</Button>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card body>
                                    <CardTitle>Delete the current amendment or revision</CardTitle>
                                    <CardText>
                                        <Button type="button" name="btnDeleteVersion" disabled={!currentAfr || (currentAfr.currentversion.versionNumber < 2)} onClick={handleDeleteVersion}>Delete current version</Button>
                                    </CardText>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Table borderless >
                                    <tbody>
                                        <tr>
                                            <td className="col-4">
                                                <b>Assigned To:</b>
                                            </td>
                                            <td className="col-4">
                                                {assignedTo}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-4">
                                                <b>Assignment Date:</b>
                                            </td>
                                            <td className="col-4">
                                                {assignmentDate}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                {(chkReturnedByDFS || btnCreateAmendtmentByDFS) && (<DiscrepancyEmail allowEdit={true} />)}
                            </Col>
                        </Row>
                    </Col>

                </Row>
            }
        </div>
    )

}

export default SummaryAdministrationTab;